"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshTokenService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../../models");
var pending_requests_registry_1 = require("../../pending-requests-registry");
var access_token_1 = require("../access-token");
var storage_service_1 = require("../storage-service");
var refreshRoute = "accessToken/refresh";
var refreshToken = function () {
    return requestRefreshToken().then(handleRefreshTokenTokenSuccess).catch(handleRefreshTokenError);
};
var requestRefreshToken = function () {
    var registeredRequest = pending_requests_registry_1.authSuitePendingRequestRegistry.getPendingRequest({
        requestKey: pending_requests_registry_1.PendingRequestKey.REFRESH_TOKEN,
    });
    return registeredRequest || registerRequestAndRefresh();
};
var registerRequestAndRefresh = function () {
    var requestKey = pending_requests_registry_1.PendingRequestKey.REFRESH_TOKEN;
    pending_requests_registry_1.authSuitePendingRequestRegistry.registerPendingRequest({
        pendingRequestPromise: getRefreshTokenAndRefresh(),
        requestKey: requestKey,
    });
    return pending_requests_registry_1.authSuitePendingRequestRegistry.getPendingRequest({ requestKey: requestKey });
};
var getRefreshTokenAndRefresh = function () {
    return storage_service_1.authSuiteDataLocalStorageService.getDeviceRefreshToken().then(function (token) {
        if (token === null) {
            throw new Error("Invalid state: deviceRefreshToken is null");
        }
        var payload = {
            refreshToken: token,
        };
        var body = JSON.stringify(payload);
        return auth_suite_fetch_1.authSuiteFetch.post({
            body: body,
            path: refreshRoute,
        });
    });
};
var handleRefreshTokenTokenSuccess = function (response) {
    storage_service_1.authSuiteDataLocalStorageService.setAccessTokens(response);
    clearRegisteredRefreshTokenRequest();
    return response;
};
var handleRefreshTokenError = function (errorResponse) {
    if (isErrorResponse(errorResponse) && errorResponse.errorCode === models_1.ErrorCode.InvalidToken) {
        storage_service_1.authSuiteDataLocalStorageService.removeAccessTokens();
        access_token_1.accessTokenService.getAccessToken();
    }
    clearRegisteredRefreshTokenRequest();
    return Promise.reject(errorResponse);
};
var isErrorResponse = function (errorResponse) {
    return "errorCode" in errorResponse;
};
var clearRegisteredRefreshTokenRequest = function () {
    pending_requests_registry_1.authSuitePendingRequestRegistry.clearRegisteredRequest({ requestKey: pending_requests_registry_1.PendingRequestKey.REFRESH_TOKEN });
};
exports.refreshTokenService = {
    refreshToken: refreshToken,
};
